import { blue, green, red, yellow } from "@material-ui/core/colors";

import BlockIcon from "@material-ui/icons/Block";
import DoneIcon from "@material-ui/icons/Done";
import MeditocHelper from "../../../utils/MeditocHelper";
import QueryBuilderIcon from "@material-ui/icons/QueryBuilder";
import TimerIcon from "@material-ui/icons/Timer";
import UpdateIcon from "@material-ui/icons/Update";

export default function HelperConsulta() {
    return (
        <MeditocHelper title="Estatus de consulta:">
            <div>
                <QueryBuilderIcon style={{ color: blue[500], verticalAlign: "middle" }} />
                {"  "}
                Creado/Programado
            </div>
            <div>
                <UpdateIcon style={{ color: blue[500], verticalAlign: "middle" }} />
                {"  "}
                Reprogramado
            </div>
            <div>
                <TimerIcon style={{ color: yellow[500], verticalAlign: "middle" }} />
                {"  "}
                En consulta
            </div>
            <div>
                <DoneIcon style={{ color: green[500], verticalAlign: "middle" }} />
                {"  "}
                Finalizado
            </div>
            <div>
                <BlockIcon style={{ color: red[500], verticalAlign: "middle" }} />
                {"  "}
                Cancelado
            </div>
        </MeditocHelper>
    );
}
